<template>
	<div class="detail_container">
		<div class="dcont_bg"></div>
		<div class="dcont_wrap">
			<div class="dc-title">{{info.yiLiaoJGMC}}</div>
			<div class="dcont_card">
				<div class="dc-list">
					<div class="dc-item">
						<div class="t-icon headImg" :class="info.sex == 2 ? 't-icon-nvshi' : 't-icon-nanshi'"></div>
						<div>{{info.name}}</div>
					</div>

					<div class="dc-item">
						<span>科室：</span>
						{{info.ruYuanKSMC}}
					</div>
				</div>

				<div class="dc-list">
					<div class="dc-item">
						<span>性别：</span>
						{{info.sex==1?'男': '女'}}
					</div>
					<div class="dc-item">
						<span>年龄：</span>
						{{info.age}}
					</div>
				</div>

				<div class="dc-list">
					<div class="dc-item">
						<span>入院：</span>
						{{info.ruYuanRQ}}
					</div>
					<div class="dc-item">
						<span>出院：</span>
						{{info.chuYuanRQ}}
					</div>
				</div>
			</div>
			<div class="dcont_card">
				<div class="dc-list" style="align-items: flex-start;">
					<div class="left-text">入院诊断：</div>
					<div class="right-text">{{ info.ruYuanQKMS }}</div>
				</div>
				<div class="dc-list" style="align-items: flex-start;">
					<div class="left-text">出院诊断：</div>
					<div class="right-text">{{ info.chuYuanZDMS }}</div>
				</div>
				<div class="dc-list" style="align-items: flex-start;">
					<div class="left-text">出院症状：</div>
					<div class="right-text">{{ info.chuYuanShiZZYTZ }}</div>
				</div>
				<div class="dc-list" style="align-items: flex-start;">
					<div class="left-text">出院医嘱：</div>
					<div class="right-text">{{ info.chuYuanYZ }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import inHospitalCard from '../../components/inHospitalCard.vue'
export default {
  name: 'inHospitalDetail',
  components: {
    inHospitalCard
  },
  data () {
    return {
      info: {},
      agentMobile: '',
      page: 1,
      pageSize: 10,
      total: 0,

      searchType: 'consultations',
      navType: '8',
      listData: [],
      allList: [],
      patId: '',
      nullFlg: false,
      list: []
    }
  },
  mounted () {
    let info = this.$route.params
    info.ruYuanRQ = info.ruYuanRQ.substring(2, 16).replaceAll('-', '/')
    info.chuYuanRQ = info.chuYuanRQ.substring(2, 16).replaceAll('-', '/')

    this.info = info
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.detail_container {
	width: 100%;
	padding-bottom: 1px;
	.dcont_bg {
		position: absolute;
		z-index: 0;
		width: 100%;
		height: 130px;
		background-color: #4bcbc3;
	}
	.dcont_wrap {
		position: relative;
		z-index: 2;
		margin: 0 12px;
		top: 18px;
		padding-bottom: 6px;
		.dc-title {
			color: #ffffff;
			font-size: 16px;
			margin-bottom: 12px;
			margin-left: 6px;
		}
		.dcont_card {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 16px 16px 12px;
			margin-bottom: 16px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
			display: flex;
			flex-direction: column;
			.dc-list {
				display: flex;
				align-items: center;
				flex-direction: row;
				justify-content: space-between;
				margin-top: 12px;
				.dc-item {
					display: flex;
					color: #303133;
					align-items: center;
					width: 60%;
					text {
						color: #606266;
					}
				}
				.left-text {
					width: 80px;
					color: #606266;
				}
				.right-text {
					flex: 1;
				}
			}
		}
	}
}
/* 头像 */
.headImg {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/inHospital/inHospital-detail.vue